import { memo } from 'react';

import { PredefinedMessages } from '../predefined-messages';

import SendIcon from '@assets/images/icons/icon-send.svg?react';

import { useSenderLogic } from './sender.hook';
import { SENDER_STRINGS } from './utils/sender.constants';

import type { TSenderLogicConfig } from './sender.types';

import * as S from './sender.styles';

const Sender = memo(({ sensitiveDataWarning, toggleSensitiveDataWarning }: TSenderLogicConfig) => {
	const { disabled, inputValue, handleChange, handleSubmit, handleSelectMessage, conversationType } =
		useSenderLogic({ sensitiveDataWarning, toggleSensitiveDataWarning });

	return (
		<>
			<PredefinedMessages type={conversationType} onSelect={handleSelectMessage} />
			<S.Container data-qa="sender-form" onSubmit={handleSubmit}>
			<input data-qa="sender-input" placeholder={SENDER_STRINGS.INPUT_PLACEHOLDER} value={inputValue} onChange={handleChange} />

				<button type="submit" disabled={disabled} data-testid="submit-msg-btn" data-qa="submit-msg-btn">
					<SendIcon
						aria-label={SENDER_STRINGS.SEND_ICON_ALT}
						width={24}
						height={24}
					/>
				</button>
			</S.Container>
		</>
	);
});

Sender.displayName = 'Sender';
export { Sender };
